import { Environment } from "../../../environment";
import { Api, IPaginacao } from "../axios-config";

//dados
export interface ITipoDeCaixa {
    idTipoCaixa: number,
    nomeTipo: string,
}

interface IListagemTipoDeCaixa {
    tipoCaixa: ITipoDeCaixa[]
    paginacao: IPaginacao,
}

const getAllByCnpj = async (page = 1, cnpj: string, estado: boolean): Promise<IListagemTipoDeCaixa | Error> => {
    try {

        const urlRelativa = `TipoCaixa_Cliente/pesquisar?cnpj=${cnpj}&PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}`;

        const { data } = await Api.get(urlRelativa);

        if (data) {
            return {
                tipoCaixa: data.tipoCaixa,
                paginacao: data.paginacao
            }
        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
};

const toggleEnabledById = async (idTipoCaixa: number): Promise<void | Error> => {
    try {
        await Api.patch(`TipoCaixa/alterarEstado?idTipoCaixa=${idTipoCaixa}`);
    } catch (error) {
        console.error(error);

        return new Error((error as { message: string }).message || 'Erro ao habilitar/desabilitar o registro');
    }
};

const create = async (dados: Omit<ITipoDeCaixa, 'idTipoCaixa'>): Promise<number | Error> => {
    try {
        const { data } = await Api.post<ITipoDeCaixa>('/TipoCaixa', dados);

        if (data) {
            return data.idTipoCaixa;
        }

        return new Error('Erro ao criar o registro do tipo caixa');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro do tipo caixa');
    }
};

const create_TipoCaixa_Cliente = async (idTipoCaixa: number, cnpj: string): Promise<{ idTipoCaixa: number, cnpj: string } | Error> => {
    try {
        const { data } = await Api.post<{ cnpj: string, idTipoCaixa: number }>('/TipoCaixa_Cliente', { idTipoCaixa: idTipoCaixa, cnpj: cnpj });

        if (data) {
            return data
        }

        return new Error('Erro ao criar o registro do cliente');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro  do cliente');
    }
};

const getById = async (idTipoCaixa: number): Promise<ITipoDeCaixa | Error> => {
    try {
        const { data } = await Api.get(`TipoCaixa?idTipoCaixa=${idTipoCaixa}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');
    }
};

const updateById = async (dados: ITipoDeCaixa): Promise<void | Error> => {
    try {
        await Api.put('TipoCaixa', dados);
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao atualizar o registro');
    }
};
// @ts-expect-error
const list = async (): Promise<ITipoDeCaixa[] | Error> => {
    try {
        const { data } = await Api.get(`TipoCaixa/listar`);

        if (data) {
            return data;
        }
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao atualizar o registro');
    }
}

export const TipoDeCaixa_Service = {
    getAllByCnpj,
    toggleEnabledById,
    create,
    create_TipoCaixa_Cliente,
    getById,
    updateById,
    list,
}